import React from 'react';
import { Typography } from '@banhala/ui-kit';
import { convertToDayJs, getCurrentTimeDiff, isNil } from 'shared/src/utils';
import { useForegroundInterval } from 'shared/src/hooks';

const getRemainTimeText = (time: string) => {
  const convertedTime = convertToDayJs(time);

  const diffSecond = getCurrentTimeDiff(convertedTime, 'second');
  const diffHourText = Math.abs(getCurrentTimeDiff(convertedTime, 'hour'));
  const diffMinute = Math.abs(getCurrentTimeDiff(convertedTime, 'minute'));
  const diffMinuteText = diffMinute - diffHourText * 60;
  const diffSecondText =
    Math.abs(getCurrentTimeDiff(convertedTime, 'second')) - diffMinute * 60;

  const isTimeOver = diffSecond > 0;

  if (isTimeOver) return null;

  return `${diffHourText < 10 ? `0${diffHourText}` : diffHourText} : ${diffMinuteText < 10 ? `0${diffMinuteText}` : diffMinuteText} : ${diffSecondText < 10 ? `0${diffSecondText}` : diffSecondText}`;
};

export const TimerText = (props: { expiredAt: string }) => {
  const [text, setText] = React.useState<string | null>(() =>
    getRemainTimeText(props.expiredAt),
  );

  useForegroundInterval(
    () => setText(getRemainTimeText(props.expiredAt)),
    text !== null ? 1000 : null,
  );

  if (isNil(text)) return null;

  return (
    <Typography color={'content_pink_primary'} type={'subtitle3'}>
      {text}
    </Typography>
  );
};
